import { graphql } from 'gatsby';
import * as React from 'react';
import { Podcast } from '../types';
import PodcastCardAlt from './PodcastCardAlt';

interface Props {
  data: Queries.PodcastCardDataFragment;
  className?: string;
  forceIconsStyle?: boolean;
}

export default function PodcastCard({
  data: { id, title, uri, excerpt, featuredImage, postSettings },
  className = '',
  forceIconsStyle = false,
}: Props) {
  const podcast: Podcast | null = React.useMemo(() => {
    if (
      !title ||
      !uri ||
      !excerpt ||
      !featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData ||
      !postSettings
    ) {
      return null;
    }

    return {
      id,
      title,
      uri,
      excerpt,
      featuredImage: featuredImage.node.localFile.childImageSharp.gatsbyImageData,
      featuredImageStyle: postSettings.featuredImageStyle,
    };
  }, [title, uri, excerpt, featuredImage, postSettings, id]);

  if (!podcast) {
    return null;
  }

  return (
    <PodcastCardAlt podcast={podcast} className={className} forceIconsStyle={forceIconsStyle} />
  );
}

export const PodcastCardDataFragment = graphql`
  fragment PodcastCardData on WpPodcast {
    id: databaseId
    title
    excerpt
    uri
    date
    featuredImage {
      ...PostImageData
    }
    podcastSettings {
      isInterviewEpisode
    }
    postSettings {
      featuredImageStyle
    }
  }
`;
